export default "__VITE_ASSET__8ee90798__"